import { render, staticRenderFns } from "./Etapa10.vue?vue&type=template&id=ba92b64e&scoped=true"
import script from "./Etapa10.vue?vue&type=script&lang=js"
export * from "./Etapa10.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=ba92b64e&prod&scoped=true&lang=scss&external"
import style1 from "./Etapa10.vue?vue&type=style&index=1&id=ba92b64e&prod&lang=css"
import style2 from "./Etapa10.vue?vue&type=style&index=2&id=ba92b64e&prod&lang=scss"
import style3 from "./Etapa10.vue?vue&type=style&index=3&id=ba92b64e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba92b64e",
  null
  
)

export default component.exports